

export const supplierApiNm = {
  getSupplier: "/supplier/getSupplier",
  insertSupplier: "/supplier/insertSupplier",
  updateSupplier: "/supplier/updateSupplier",
  deleteSupplier: "/supplier/deleteSupplier"
}

export const supplierColNm = {
  Name: "ชื่อ Supplier",
  SName: "ชื่อย่อ",
  Addr: "ที่อยู่",
  TaxId: "เลขประจำตัวผู้เสียภาษี",
  BrchNo: "เลขที่สาขา",
  Tel: "โทร.",
  Note: "Note",
  IsActv: "IsActv",
  Dist: "ระยะทาง",
  XpssSupCod: "รหัสผู้จำหน่าย Express",
  Rmk: "หมายเหตุ",
}